import { Route, Routes } from 'react-router-dom';
import './App.scss';
import TitleUpdater from './components/TitleUpdater/TitleUpdater';
import Home from './pages/Home/Home';
import NotFound from './pages/NotFound/NotFound';

import { ToggleMenuProvider } from './entities/toggleMenuContext';
import MobileOverlay from './components/MobileOverlay/MobileOverlay';

import { linksData } from './data/data';
import useScrollRestoration from './components/useScrollRestoration/useScrollRestoration';

function App() {
  useScrollRestoration();

  return (
    <div className="App">
      <TitleUpdater />
      <ToggleMenuProvider>
        <MobileOverlay links={linksData} />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

      </ToggleMenuProvider>
    </div>
  );
}

export default App;
